import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { useState } from 'react';
import { HUBSPOT_CREDITS_CARDS_SECTION } from '../../../constants/tracking/TrackingSources';
import { useMedia } from '../../../hooks/useMedia';
import ProductAndServicesCatalogLink from '../../ProductAndServicesCatalogLink';
import MobileMerchCardSelectorButtons from '../../mobile/MobileMerchCardSelectorButtons';
import { MerchCardShadowColumns } from '../MerchCardSharedComponents';
import HubSpotCreditsTile from './HubSpotCreditsTile';
import { SIZE_TO_LOCATION_MAP } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const HubSpotCreditsTilesContainer = ({
  screen,
  hubSpotCreditsFeature,
  productApiName,
  unlockHubSpotCreditsSkuIds,
  shouldShowUnlockHubSpotCreditsInfo
}) => {
  const isMobile = useMedia('tabletPortrait');
  const [selectedSize, setSelectedSize] = useState('SMALL');
  if (isMobile) return /*#__PURE__*/_jsxs(PageSection, {
    children: [/*#__PURE__*/_jsx(MobileMerchCardSelectorButtons, {
      options: ['SMALL', 'MEDIUM', 'LARGE'],
      onClick: setSelectedSize,
      selectedOption: selectedSize
    }), /*#__PURE__*/_jsx(View, {
      marginBlockStart: "500",
      marginBlockEnd: "800",
      children: /*#__PURE__*/_jsx(HubSpotCreditsTile, {
        size: selectedSize,
        location: SIZE_TO_LOCATION_MAP[selectedSize],
        hubSpotCreditsFeature: hubSpotCreditsFeature,
        screen: screen,
        productApiName: productApiName,
        unlockHubSpotCreditsSkuIds: unlockHubSpotCreditsSkuIds,
        shouldShowUnlockHubSpotCreditsInfo: shouldShowUnlockHubSpotCreditsInfo,
        isCollapsible: true
      })
    }), /*#__PURE__*/_jsx(Flex, {
      justifyContent: "center",
      children: /*#__PURE__*/_jsx(ProductAndServicesCatalogLink, {
        trackingSource: HUBSPOT_CREDITS_CARDS_SECTION,
        section: "#HubSpotCreditsRateSheet",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.hubspot-credits.links.viewCreditsRateSheet"
        })
      })
    })]
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(PageSection, {
      hideOverflow: false,
      children: [/*#__PURE__*/_jsx(View, {
        position: "relative",
        marginBlockEnd: "600",
        children: /*#__PURE__*/_jsxs(MerchCardShadowColumns, {
          columns: 3,
          children: [/*#__PURE__*/_jsx(HubSpotCreditsTile, {
            size: "SMALL",
            location: "HUBSPOT_CREDITS_MERCH_CARD_SMALL",
            hubSpotCreditsFeature: hubSpotCreditsFeature,
            screen: screen,
            productApiName: productApiName,
            unlockHubSpotCreditsSkuIds: unlockHubSpotCreditsSkuIds,
            shouldShowUnlockHubSpotCreditsInfo: shouldShowUnlockHubSpotCreditsInfo
          }), /*#__PURE__*/_jsx(HubSpotCreditsTile, {
            size: "MEDIUM",
            location: "HUBSPOT_CREDITS_MERCH_CARD_MEDIUM_LARGE",
            hubSpotCreditsFeature: hubSpotCreditsFeature,
            screen: screen,
            productApiName: productApiName,
            unlockHubSpotCreditsSkuIds: unlockHubSpotCreditsSkuIds,
            shouldShowUnlockHubSpotCreditsInfo: shouldShowUnlockHubSpotCreditsInfo
          }), /*#__PURE__*/_jsx(HubSpotCreditsTile, {
            size: "LARGE",
            location: "HUBSPOT_CREDITS_MERCH_CARD_MEDIUM_LARGE",
            hubSpotCreditsFeature: hubSpotCreditsFeature,
            screen: screen,
            productApiName: productApiName,
            unlockHubSpotCreditsSkuIds: unlockHubSpotCreditsSkuIds,
            shouldShowUnlockHubSpotCreditsInfo: shouldShowUnlockHubSpotCreditsInfo
          })]
        })
      }), /*#__PURE__*/_jsx(Flex, {
        justifyContent: "center",
        children: /*#__PURE__*/_jsx(ProductAndServicesCatalogLink, {
          trackingSource: HUBSPOT_CREDITS_CARDS_SECTION,
          section: "#HubSpotCreditsRateSheet",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricingPage.pages.hubspot-credits.links.viewCreditsRateSheet"
          })
        })
      })]
    })
  });
};